define('lq/onlongpress',[
    'underscore',
    'jquery',
    'detectmobilebrowser'
], function (_, $) {
    'use strict';

    var eventToTrigger = null;
    var timerExceeded = false;
    var scrolledOrMoved = false;

    var checkForSelection = function (drop) {
        return drop.isEventEnabled('selected') ||
            drop.isEventEnabled('deselected') ||
            drop.isEventEnabled('itemSelected') ||
            drop.isEventEnabled('itemDeselected');
    };

    function OnLongPress() { };

    OnLongPress.prototype.applyLongPressOnElement = function ($element, drop, eventArg, callback, eventName, $scrollableElement, unhandledClickCallback) {
        if (this.drop)
            drop = this.drop;
        if (drop.$element && drop.isEventEnabled('onLongPress'))
            drop.$element.addClass('prevent-selection');
        eventName = eventName || 'onLongPress';
        var self = this;
        if ($scrollableElement) {
            $scrollableElement.on('touchmove', function () {
                scrolledOrMoved = true;
                eventToTrigger = null;
                clearTimeout(self.pressTimer);
            });
        }

        var timeout = drop.data.longPressDelay ? drop.data.longPressDelay : 1000;

        var longPressEvent = drop.getEventDataFor(eventName);
        var clickedEvent = drop.getEventDataFor('clicked');
        var end = function(e) {
            if (drop.rootDrop && drop.rootDrop.pointAndClickActive) return;

            if (unhandledClickCallback) {
                unhandledClickCallback(e);
            }

            if (timerExceeded) {
                if (!parentStillHasSomeEvents(drop.parent)) {
                    timerExceeded = false;
                }
            } else if (!scrolledOrMoved) {
                if (eventToTrigger === null) {
                    if (checkForSelection(drop)) { // In case we have a selected we must have a callback
                        eventToTrigger = {
                            callback: !callback ? null : function () { callback(e); }
                        };
                    } else if (drop.isEventEnabled('clicked')) {
                        eventToTrigger = {
                            name: drop.data.name,
                            drop: drop,
                            event: 'clicked',
                            eventName: clickedEvent.raisedEventName,
                            eventArg: eventArg,
                            callback: !callback ? null : function () { callback(e); }
                        };
                    }
                }

                if (!parentStillHasSomeEvents(drop.parent)) {
                    self.triggerTheCorrectEvent(e);
                }
            }
            clearTimeout(self.pressTimer);
        }

        if ($.browser.mobile) {
            $element.on('touchend', function () {
                clearTimeout(self.pressTimer);
            });

            var eventName = 'clicked';
            var jsEventName = 'click';

            var eventData = drop.getEventDataFor(eventName);
            var jsEventNameWithNamespace = jsEventName + ".licquidEventTrigger-" + eventName;

            $element.off(jsEventNameWithNamespace);
            if (eventData.enabled || checkForSelection(drop)) {
                drop.subscribeEventHandler($element, jsEventNameWithNamespace, end);
            }
        } else {
            $element.on('click', end);
        }

        var start = function(e) {
            timerExceeded = false;
            scrolledOrMoved = false;
            self.pressTimer = window.setTimeout(function () {
                if (!drop.piping) return;

                if (drop.isEventEnabled('onLongPress') && eventToTrigger === null) {
                    eventToTrigger = {
                        name: drop.data.name,
                        drop: drop,
                        event: 'onLongPress',
                        eventName: longPressEvent.raisedEventName,
                        eventArg: eventArg
                    };
                }

                if (!parentStillHasSomeEvents(drop.parent)) {
                    drop.piping.$app.addClass('prevent-selection');
                    self.triggerTheCorrectEvent(e);
                    setTimeout(function () {
                        if (!drop.piping) return;

                        drop.piping.$app.removeClass('prevent-selection');
                    }, 10);
                }
            }, timeout);
        }
        if ($.browser.mobile) {
            $element.on('touchstart', start);
        } else {
            $element.on('mousedown', start);
        }
        var parentStillHasSomeEvents = function(drop) {
            if (drop.cancelOtherEvents) {
                drop.cancelOtherEvents = false;
                return true;
            }
            if (!drop ||
                drop.type === "CalendarWeekView" || // The calendar is special, because the
                drop.type === "CalendarDayView" || // child drop is next to the the parent drop
                drop.type === "CalendarPlanningView") { 
                return false;
            }
            if (drop.isEventEnabled('onLongPress') || drop.isEventEnabled('clicked') || checkForSelection(drop)) {
                return true;
            }
            if (drop.parent) {
                if (parentStillHasSomeEvents(drop.parent)) {
                    return true;
                }
            }
            return false;
        };
    };

    OnLongPress.prototype.triggerTheCorrectEvent = function (e) {
        if (this.isExecuting || eventToTrigger === null) {
            return;
        }
        
        var onExecuted = this.endExecution.bind(this);
        
        if (eventToTrigger.callback) {
            eventToTrigger.callback();
        } else if (eventToTrigger.eventArg === null || eventToTrigger.eventArg === undefined) {
            this.startExecution();
            eventToTrigger.drop.triggerEvent(eventToTrigger.eventName, null, null, null, null, null, onExecuted);
        } else {
            if (typeof eventToTrigger.eventArg === 'function') {
                var determinedEventArg = eventToTrigger.eventArg(e);
                this.startExecution();
                eventToTrigger.drop.triggerEvent(eventToTrigger.eventName, determinedEventArg, null, null, null, null, onExecuted);
            } else {
                this.startExecution();
                eventToTrigger.drop.triggerEvent(eventToTrigger.eventName, eventToTrigger.eventArg, null, null, null, null, onExecuted);
            }
        }
        if (eventToTrigger.event === 'onLongPress') {
            timerExceeded = true;
        } else {
            timerExceeded = false;
        }

        eventToTrigger = null;
    };

    OnLongPress.prototype.startExecution = function () {
        this.isExecuting = true;
    };

    OnLongPress.prototype.endExecution = function () {
        this.isExecuting = false;
    };

    return OnLongPress;
});

